import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'

import { GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME } from './GretaAIChatNameField.constants'

export function getGretaAIChatNameFieldNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = event.target.value.trimStart()

  return nextEvent
}

export function getGretaAIChatNameFormInitialValues(name = EMPTY_STRING) {
  return { [GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME]: name }
}

export function getGretaAIChatNameFormValidationSchema(maxLength) {
  return Yup.object({
    [GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME]: Yup.string()
      .ensure()
      .trim()
      .max(maxLength)
      .required(true),
  })
}

export function getIsGretaAIChatNameFormValid({ validationSchema, values }) {
  return validationSchema.isValidSync(values)
}
